(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neills-pay-over-time"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('neills-payment-options')){
    class NeillsPaymentOptions extends HTMLElement{
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
        this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
        this.section=this.closest('.shopify-section');
        this.onVariant=event=>this.update(event.detail?.variant);
        this.section?.addEventListener('on:variant:change',this.onVariant);
        this.update(this.variants.find(variant=>String(variant.id)===this.dataset.variant));
      }
      disconnectedCallback(){this.section?.removeEventListener('on:variant:change',this.onVariant);this.initialized=false;}
      update(variant){
        const currency=this.dataset.currency||'USD';
        const whole=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency,maximumFractionDigits:0});
        const precise=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency,minimumFractionDigits:2,maximumFractionDigits:2});
        [12,36].forEach(term=>{
          const amount=term===12?variant?.price:variant?.compare_at_price;
          const valid=variant&&Number.isFinite(amount)&&amount>0&&(term===12||amount>=variant.price);
          const payment=this.querySelector('[data-payment="'+term+'"]');
          if(!payment)return;
          payment.textContent=valid?this.labels.monthly.replace('__AMOUNT__',whole.format(Math.ceil(amount/(term*100)))):variant?this.labels.missing:this.labels.choose;
          payment.classList.toggle('npo-unavailable',!valid);
          const basis=this.querySelector('[data-basis="'+term+'"]');
          basis.textContent=valid?(term===12?this.labels.sale:this.labels.regular)+' '+precise.format(amount/100):'';
          basis.hidden=!valid;
          this.querySelector('[data-below="'+term+'"]').hidden=!valid||amount>=(term===12?39999:99999);
        });
      }
    }
    customElements.define('neills-payment-options',NeillsPaymentOptions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neills-review-promo-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('neills-review-card')) {
    class NeillsReviewCard extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.index = 0;
        this.timer = null;
        this.retry = null;
        this.inView = false;
        this.hovered = false;
        this.focused = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.auto !== 'true' || this.motion.matches;
        this.content = this.querySelector('.nrc-content');
        this.controls = this.querySelector('.nrc-controls');
        this.toggle = this.querySelector('.nrc-toggle');
        this.promoItem = this.closest('li');
        if (this.promoItem) this.promoItem.hidden = true;
        const opts = { signal: this.abort.signal };
        this.querySelector('.nrc-prev').addEventListener('click', () => this.step(-1, true), opts);
        this.querySelector('.nrc-next').addEventListener('click', () => this.step(1, true), opts);
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, opts);
        this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, opts);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, opts);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, opts);
        this.addEventListener('focusout', e => { this.focused = this.contains(e.relatedTarget); this.schedule(); }, opts);
        document.addEventListener('visibilitychange', () => this.schedule(), opts);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.updateToggle(); this.schedule(); }, opts);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.loadReviews(0);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.retry);
        this.abort?.abort();
        this.observer?.disconnect();
      }
      safeGoogleUrl(value) {
        try {
          const url = new URL(value);
          if (url.protocol === 'https:' && (url.hostname === 'google.com' || url.hostname.endsWith('.google.com'))) return url.href;
        } catch {}
        return '';
      }
      loadReviews(attempt) {
        const feed = window._appioGoogleReviewsData;
        if (!Array.isArray(feed?.reviews)) {
          if (attempt < 20) this.retry = setTimeout(() => this.loadReviews(attempt + 1), 500);
          return;
        }
        const seen = new Set();
        this.reviews = feed.reviews.filter(review => {
          const key = review.reviewId || review.id;
          if (Number(review.rating) !== 5 || typeof review.originalText !== 'string' || !review.originalText.trim() || !review.authorName || !this.safeGoogleUrl(review.reviewUrl) || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        if (!this.reviews.length) return;
        this.index = Math.floor(Math.random() * this.reviews.length);
        this.renderReview();
        this.controls.hidden = this.reviews.length < 2;
        this.updateToggle();
        if (this.promoItem) this.promoItem.hidden = false;
        this.schedule();
      }
      updateToggle() {
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
      }
      step(direction, manual = false) {
        if (!this.reviews?.length) return;
        if (manual) { this.paused = true; this.updateToggle(); }
        this.index = (this.index + direction + this.reviews.length) % this.reviews.length;
        this.content.setAttribute('aria-live', manual ? 'polite' : 'off');
        this.renderReview();
        this.schedule();
      }
      renderReview() {
        const review = this.reviews[this.index];
        const text = review.originalText.trim();
        const excerpt = text.length > 130;
        let quote = text;
        if (excerpt) {
          quote = text.slice(0, 130);
          const space = quote.lastIndexOf(' ');
          if (space > 80) quote = quote.slice(0, space);
          quote = quote.trimEnd() + '…';
        }
        this.querySelector('.nrc-kind').textContent = excerpt ? this.dataset.excerptLabel : this.dataset.fullLabel;
        this.querySelector('.nrc-quote').textContent = '“' + quote + '”';
        this.querySelector('.nrc-author').textContent = review.authorName;
        const dateElement = this.querySelector('.nrc-date');
        const dateValue = String(review.createdAt || '').slice(0, 10);
        const date = /^\d{4}-\d{2}-\d{2}$/.test(dateValue) ? new Date(dateValue + 'T12:00:00Z') : null;
        if (date && !Number.isNaN(date.getTime())) {
          dateElement.dateTime = dateValue;
          dateElement.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month:'short', day:'numeric', year:'numeric', timeZone:'UTC' }).format(date);
        } else { dateElement.removeAttribute('datetime'); dateElement.textContent = ''; }
        const link = this.querySelector('.nrc-original');
        link.href = this.safeGoogleUrl(review.reviewUrl);
        link.hidden = false;
        this.dataset.reviewId = String(review.reviewId || review.id);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.inView || this.paused || this.hovered || this.focused || document.hidden || (this.reviews?.length || 0) < 2) return;
        const interval = Math.max(6000, Number(this.dataset.interval) || 10000);
        this.timer = setTimeout(() => this.step(1), interval);
      }
    }
    customElements.define('neills-review-card', NeillsReviewCard);
  }
  } catch(e) { console.error(e); }
})();

})();
